import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis, Tooltip,
  AggregationInterval, ArgumentAxis, Label, ZoomAndPan,
  TickInterval, CommonSeriesSettings, } from 'devextreme-react/chart';
import { SelectBox } from 'devextreme-react/select-box';
import { groupBy, calcWeightData, Array_Average, Quartile } from '../../utils/miscUtil';
import { AvgTable } from '../'

const filter_fields = ["1", "2", "3", "4", "73", "77",];

export default function HSEProduction(props) {
  const [data, setData] = useState();
  const [companiesList, setCompaniesList] = useState([]);
  const [reportingCompanies, setReportingCompanies] = useState([]);
  const [metrics, setMetrics] = useState();
  const [metric, setMetric] = useState(null);
  const [metricDetails, setMetricDetails] = useState(null);
  const [metricsChoices, setMetricsChoices] = useState();
  const [boundaries, setBoundaries] = useState([]);
  const [boundary, setBoundary] = useState(null);
  const [weightData, setWeightData] = useState({});
  const [weight, setWeight] = useState("Oil & Gas Weighted");
  const [avgData, setAvgData] = useState(null);

  useEffect(() => {
    setWeightData(calcWeightData(props.data, props.year));
    var fd = props.data.filter((e) => {return filter_fields.includes(e["Identifier"])});
    for (var i=0; i<fd.length; i++) {
      fd[i]['company_'+fd[i].company_id] = parseFloat(fd[i].value?.replaceAll(",","")) || null;
      fd[i]['date'] = new Date(fd[i]['year'], 0)
    }
    fd = groupBy(fd, 'Identifier')
    let ml = []
    let fdk = Object.keys(fd);
    for (i=0; i<fdk.length; i++) {
     if (fd[fdk[i]][0]['Display Title']) {
       ml.push({id:fd[fdk[i]][0]['Identifier'], name:fd[fdk[i]][0]['Display Title'], details:fd[fdk[i]][0]['Details'], boundary:fd[fdk[i]][0]['Subcategory']})
     } else {
       ml.push({id:fd[fdk[i]][0]['Identifier'], name:fd[fdk[i]][0]['Details'], boundary:fd[fdk[i]][0]['Subcategory']})
     }
    }
    setMetricsChoices(Object.keys(groupBy(ml, 'name')).sort());
    setMetrics(ml);
  }, [props.data, props.year]);

  const customizeTooltip = useCallback((pointInfo) => {
    var cn = ""
    if (pointInfo.seriesName.includes("Series")) {
      cn = "Company "+pointInfo.seriesName.split(" ")[1]
    } else {
      cn = pointInfo.seriesName
    }
    const y = pointInfo.argument.toLocaleString('default', {year: 'numeric'});
    var txt = ''
    txt = `<div><div class="tooltip-header">${y}</div><div class="tooltip-body">`
    txt = txt+`<div>${cn}: ${pointInfo.value}</div>`
    txt=txt+`</div></div>`
    return {
      html: txt,
    }
  }, []);

  const customizeTooltip2 = useCallback((pointInfo) => {
    const y = pointInfo.argument.toLocaleString('default', { year: 'numeric'});
    var txt = ''
    txt = `<div><div class="tooltip-header">${y} - ${pointInfo.value} Companies</div></div>`
    return {
      html: txt,
    }
  }, []);

  const onMetricChanged = useCallback((e) => {
    let bl = metrics.filter((it) => it.name===e.value)
    bl = Object.keys(groupBy(bl, 'boundary'))
    setMetric(e.value);
    setBoundaries(bl);
    if (bl.length > 0) {
      setBoundary(bl[0]);
    }
  }, [metrics])

  const onBoundaryChanged = useCallback((e) => {
    setBoundary(e.value);
  }, [setBoundary])

  const onWeightChanged = useCallback((e) => {
    setWeight(e.value);
  }, [setWeight])

  useEffect(() => {
    if (!metrics) {
      return
    }
    let m = metrics.filter((it) => it.name === metric && it.boundary ===boundary);
    if (m.length !== 1) {
      return
    }
    m = m[0]
    var fd = props.data.filter((it) => it['Subcategory']===boundary && it['Identifier']===m.id);
    setMetricDetails(m.details)

    var fd1 = groupBy(fd,"company_id");
    for (const [key] of Object.entries(fd1)) {
      var val = 0;
      var cn = null;
      for (var i=0; i<fd1[key].length; i++){
        if (fd1[key][i]["year"] === props.year) {
          val = fd1[key][i]["value"];
          cn = fd1[key][i]["company_name"]
        }
      }
      fd1[key] = {value: parseFloat(val?.replaceAll(",","")) || null, company_name: cn};
    }
    fd1 = Object.keys(fd1).map((key) => ({company_id:key, value:fd1[key].value, company_name:fd1[key].company_name}));
    fd1 = fd1.filter((it) => weight.includes(weightData[it["company_id"]]))
    fd1 = fd1.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
    setCompaniesList(fd1);

    fd1 = groupBy(fd,"year");
    for (const [key] of Object.entries(fd1)) {
      var vals = [];
      var v = 0;
      for (i=0; i<fd1[key].length; i++){
        v = parseFloat(fd1[key][i]["value"]?.replaceAll(",",""));
        if (!isNaN(v)) {
          vals.push(v)
        }
      }

      fd1[key] = {avg: Array_Average(vals), q25: Quartile(vals, 0.25), q50: Quartile(vals, 0.50), q75: Quartile(vals, 0.75)};
    }
    fd1 = Object.keys(fd1).map((key) => ({date: new Date(key, 0), ...fd1[key]}));
    setAvgData(fd1);
    fd.push(...fd1)
    setData(fd);

    fd = groupBy(fd.filter((it) => !isNaN(parseFloat(it['value']?.replaceAll(",","")))),"year");
    fd = Object.keys(fd).map((key) => ({date: new Date(key, 0) , count: fd[key].filter((it) => weight.includes(weightData[it["company_id"]])).length}));
    setReportingCompanies(fd);

  }, [props.data, props.year, metric, metrics, boundary, weight, weightData]);

  return (
    <div className="d-flex flex-row">
      <div className="d-flex flex-column me-4" style={{width:"30%"}}>
        <SelectBox
            dataSource={metricsChoices}
            showDropDownButton={true}
            activeStateEnabled={true}
            placeholder={"Select Metric"}
            label={"Metric"}
            labelMode="floating"
            onValueChanged={onMetricChanged}
        >
        </SelectBox>
        {false && <div className="mb-2"/>}
        {false && <SelectBox
            dataSource={boundaries}
            value={boundary}
            showDropDownButton={true}
            activeStateEnabled={true}
            onValueChanged={onBoundaryChanged}
            label={"Boundary"}
            labelMode="floating"
            placeholder={"Select Boundary"}
            noDataText={"Select a metric first"}
        >
        </SelectBox>}
        <div className="mb-2"/>
        <SelectBox
            dataSource={["Gas Weighted", "Oil Weighted", "Oil & Gas Weighted"]}
            value={weight}
            showDropDownButton={true}
            activeStateEnabled={true}
            onValueChanged={onWeightChanged}
            label={"Gas/Oil Weighted"}
            labelMode="floating"
            placeholder={"Gas/Oil Weighted"}
            noDataText={"Select a metric first"}
        >
        </SelectBox>
        <div className="mb-2"/>
        <Chart
          id="chart"
          dataSource={reportingCompanies}
          title={"Reporting Companies"}
          rotated={true}
          height="270px"
        >
          <ArgumentAxis aggregatedPointsPosition="crossTicks">
            <AggregationInterval years={1} />
            <TickInterval years={1} />
          </ArgumentAxis>
          <CommonSeriesSettings
            argumentField="date"
          >
          </CommonSeriesSettings>
          <Series
            type="bar"
            valueField={"count"}
            color="rgba(0, 162, 200, 0.8)"
          >
            <Label visible={true}/>

          </Series>

          <ValueAxis showZero={true} allowDecimal={false} tickInterval={5}>
          </ValueAxis>
          <Legend visible={false} />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip2}
          />
        </Chart>
      </div>
      <div className="d-flex flex-column" style={{width:"70%"}}>
        {metric && <h5>{metric}</h5>}
        {metricDetails && <p>{metricDetails}</p>}
        <Chart
          id="chart"
          dataSource={data}
          height="50vh"
        >
          <ArgumentAxis aggregatedPointsPosition="crossTicks">
            <AggregationInterval years={1} />
            <TickInterval years={1} />
          </ArgumentAxis>
          <CommonSeriesSettings
            argumentField="date"
          >
          </CommonSeriesSettings>
          {companiesList.map((e) => (<Series
            type="bar"
            key={e.company_id}
            valueField={"company_"+e.company_id}
            showInLegend={false}
            name={e.company_name}
            color={e.company_name?"rgba(0, 162, 200, 0.8)":"rgba(236, 80, 32, 0.5)"}
            ignoreEmptyPoints={true}
          />))}
          <Series
            type="line"
            valueField="avg"
            name="Average"
            color="rgba(20, 77, 109, 1)"
            dashStyle="solid"
          />
          <Series
            type="line"
            valueField="q25"
            name="1st Quartile"
            color="rgba(20, 77, 109, 0.25)"
            dashStyle="dot"
          />
          <Series
            type="line"
            valueField="q50"
            name="2nd Quartile"
            color="rgba(20, 77, 109, 0.5)"
            dashStyle="dash"
          />
          <Series
            type="line"
            valueField="q75"
            name="3rd Quartile"
            color="rgba(20, 77, 109, 0.75)"
            dashStyle="longDash"
          />
          <ValueAxis showZero={true} />

          <Legend
            verticalAlignment="bottom"
            horizontalAlignment="center"
            itemTextPosition="bottom"
          />
          <ZoomAndPan
            valueAxis="both"
            argumentAxis="both"
            dragToZoom={true}
            allowMouseWheel={true}
            panKey="shift"
          />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
          />
        </Chart>
        <AvgTable data={avgData}/>
      </div>
    </div>
  );
}
